<script setup lang="ts">
import { computed } from "vue";

import { cardActions } from "@/action/cardActions";
import { cardKey } from "@/components/StickyNote/injectKeys";
import ArtSelector from "@/components/StickyNote/internal/ArtSelector/ArtSelector.vue";
import { dropdownKey } from "@/components/ui/DropdownMenu/injectKeys";
import type { Art } from "@/model/session";
import { NO_ART, useArtStore } from "@/store/art";
import { injectStrict } from "@/utils/vue";

const card = injectStrict(cardKey);
const dropdown = injectStrict(dropdownKey);

const arts = computed(() => useArtStore().arts);
const selected = computed(() => arts.value.find((art) => art.id === card.artId));

const handleArtChange = (art: Art | null) => {
  cardActions.setArt("action-menu", card.id, art?.id || NO_ART.id);
  dropdown.close();
};
</script>

<template>
  <ArtSelector class="change-art" :selected :arts @select="handleArtChange" />
</template>
